import { useEffect, useCallback } from 'react';
import { useAppContext } from '../../../AppProvider';

const Experiment = () => {
  const { dispatch } = useAppContext();

  const showNewPrice = useCallback(() => {
    if (window.ExperimentNewPrice?.isActive) {
      dispatch({ type: 'SET_EXP_NEW_PRICE' });
    }
  }, [dispatch]);

  useEffect(() => {
    window.showNewPrice = showNewPrice;
    return () => {
      delete window.showNewPrice;
    };
  }, [showNewPrice]);

  return null;
};

export default Experiment;
